import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import cn from 'classnames';
import { useAppContext } from 'contexts/AppContext';
import { ReactComponent as NotificationIcon } from 'assets/icons/ui/notyfication.svg';
import FsNotificationFixedBox from 'ui-elements/boxes/FsNotificationFixedBox';
import { StyledIconButton } from './FsNotificationButton.style-elements';

const FsNotificationButton: React.FC = () => {
  const {
    notifications: { getNotificationList, init: initNotificationList },
  } = useAppContext();
  const notifications = getNotificationList();
  const areNotifications = !!notifications.length;
  const withUnreadStatus = notifications.some(({ isRead }) => !isRead);
  const [showNotifications, setShowNotifications] = useState<boolean>(false);

  useEffect(() => {
    initNotificationList();
  }, [initNotificationList]);

  return areNotifications ? (
    <>
      <StyledIconButton
        onClick={() => setShowNotifications(true)}
        className={cn({ withUnreadStatus })}
      >
        <NotificationIcon />
      </StyledIconButton>
      <FsNotificationFixedBox
        show={showNotifications}
        notifications={notifications}
        onClose={() => setShowNotifications(false)}
      />
    </>
  ) : null;
};

export default observer(FsNotificationButton);
